var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m477.64 38.26a4.75 4.75 0 0 0 -3.55-3.66c-58.57-14.32-193.9 36.71-267.22 110a317 317 0 0 0 -35.63 42.1c-22.61-2-45.22-.33-64.49 8.07-54.37 23.93-70.2 86.37-74.61 113.23a9.64 9.64 0 0 0 10.55 11.2l87.31-9.63a194.1 194.1 0 0 0 1.19 19.7 19.53 19.53 0 0 0 5.7 12l33.81 33.73a19.59 19.59 0 0 0 12 5.7 193.53 193.53 0 0 0 19.59 1.19l-9.58 87.2a9.65 9.65 0 0 0 11.2 10.55c26.81-4.3 89.36-20.13 113.15-74.5 8.4-19.27 10.12-41.77 8.18-64.27a317.66 317.66 0 0 0 42.21-35.64c73.55-73.18 124.29-205.49 110.19-266.97zm-183.57 179.67a48 48 0 1 1 67.86 0 47.95 47.95 0 0 1 -67.86 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m168.4 399.43c-5.48 5.49-14.27 7.63-24.85 9.46-23.77 4.05-44.76-16.49-40.49-40.52 1.63-9.11 6.45-21.88 9.45-24.88a4.37 4.37 0 0 0 -3.65-7.45 60 60 0 0 0 -35.13 17.12c-23.51 23.53-25.73 110.84-25.73 110.84s87.36-2.22 110.87-25.75a59.69 59.69 0 0 0 17.13-35.16c.37-4.18-4.72-6.67-7.6-3.66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.584aa32343b1c5ef718465f75e9aeec6.svg";
export { ForwardRef as ReactComponent };